/* Pawrka theme JS — bundle & save, cart drawer, gallery, size finder, carousels */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const PW = window.pw || {};

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = PW.moneyFormat || '${{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2);
    const withComma = two.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/<[^>]*>/g, '');
  }

  /* ---------- overlays ---------- */
  const ov = $('#pwOverlay');
  function open(id) { const el = document.getElementById(id); if (!el) return; el.classList.add('show'); ov && ov.classList.add('show'); }
  function closeAll() { $$('.drawer.show,.modal.show').forEach(e => e.classList.remove('show')); ov && ov.classList.remove('show'); }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); open(o.dataset.open); }
    if (e.target.closest('[data-close]') || e.target === ov) closeAll();
    const c = e.target.closest('[data-open-cart]'); if (c) { e.preventDefault(); openCart(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  let tt; function toast(m) { const t = $('#pwToast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 2400); }

  /* ---------- accordions ---------- */
  $$('.acc>button').forEach(b => b.addEventListener('click', () => {
    const a = b.parentElement, bd = a.querySelector('.body'); a.classList.toggle('open');
    bd.style.maxHeight = a.classList.contains('open') ? bd.scrollHeight + 'px' : 0;
  }));

  /* ---------- countdown (real fixed deadline) ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime(); if (isNaN(end)) return;
    const p = n => String(Math.floor(n)).padStart(2, '0');
    const tick = () => { const d = Math.max(0, end - Date.now()) / 1000;
      $('[data-d]', el).textContent = p(d / 86400); $('[data-h]', el).textContent = p(d % 86400 / 3600);
      $('[data-m]', el).textContent = p(d % 3600 / 60); $('[data-s]', el).textContent = p(d % 60);
      if (d <= 0) el.closest('.announce') && (el.style.display = 'none'); };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- size chart data ---------- */
  const SIZES = (PW.sizeChart || '').split('\n').map(l => l.split('|').map(s => s.trim())).filter(c => c.length >= 6)
    .map(c => ({ s: c[0], wMax: parseFloat(c[4]), cMax: parseFloat(c[5]) }));

  /* ---------- icons ---------- */
  const IC = {
    xmas: '<svg viewBox="0 0 24 24"><path d="M12 3l3 5h-2l3 5h-2l3 5H7l3-5H8l3-5H9z"/><path d="M12 18v3"/></svg>',
    cream: '<svg viewBox="0 0 24 24"><rect x="5" y="9" width="14" height="11" rx="3"/><path d="M7 9V6h10v3"/><path d="M9.5 14.5c0-1 1-2 2.5-2s2.5 1 2.5 2-1 2-2.5 2-2.5-1-2.5-2z"/></svg>',
    guar: '<svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4h4"/><text x="12.3" y="15.3" text-anchor="middle" font-size="7.5" font-weight="800" fill="currentColor" stroke="none" font-family="Nunito">30</text></svg>',
    protect: '<svg viewBox="0 0 24 24"><path d="M3 8l7-4 7 4v8l-7 4-7-4z"/><path d="M15 13l3-1 3 1v3c0 2-1.4 3.4-3 4-1.6-.6-3-2-3-4z"/></svg>',
    ship: '<svg viewBox="0 0 24 24"><path d="M2 7h12v9H2zM14 10h4l3 3v3h-7"/><circle cx="6" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>'
  };
  const icon = a => a.img ? `<img src="${a.img}" alt="" style="width:100%;height:100%;object-fit:cover">` : (IC[a.icon] || IC.protect);

  /* ---------- product: gallery ---------- */
  const prod = $('[data-pw-product]');
  if (prod) {
    const slides = $('[data-slides]', prod), imgs = $$('img', slides), dots = $('[data-dots]', prod), th = $('[data-thumbs]', prod);
    dots.innerHTML = imgs.map(() => '<i></i>').join('');
    imgs.forEach((im, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.innerHTML = `<img src="${im.currentSrc || im.src}" alt="" loading="lazy">`; b.onclick = () => slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); th.appendChild(b); });
    const mark = () => { const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
      [...th.children].forEach((b, j) => b.classList.toggle('on', j === i)); [...dots.children].forEach((d, j) => d.classList.toggle('on', j === i)); };
    slides.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true }); mark();

    /* ---------- product: bundle & save ---------- */
    const cfg = JSON.parse($('[data-pw-config]', prod).textContent);
    const V = cfg.variants;
    const first = V.find(v => v.available) || V[0];
    const unit = first.price, unitCompare = first.compare;
    const B = [
      { id: 1, qty: 1, title: cfg.b1.title, sub: cfg.b1.sub, price: unit, compare: unitCompare, addons: cfg.addons.filter(a => a.buy1).map(a => ({ ...a, on: a.display ? false : a.checked, fixed: a.display })) },
    ];
    if (cfg.b2.enabled) B.push({ id: 2, qty: 2, title: cfg.b2.title, sub: cfg.b2.sub, price: unit * 2 - cfg.b2.discount, compare: unitCompare * 2, popular: cfg.b2.badge, addons: cfg.addons.filter(a => a.buy2).map(a => ({ ...a, on: true, fixed: true, freeGift: true })) });
    let active = 1;
    const sizeOpts = V.map(v => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${v.option1 || v.title}${v.available ? '' : ' — sold out'}</option>`).join('');
    const box = $('[data-bundles]', prod);
    const saveTag = b => b.id === 1 ? `SAVE ${Math.round((1 - b.price / b.compare) * 100)}%` : `SAVE ${money(b.compare - b.price)}`;

    function render() {
      const keep = $$('.szsel', box).map(s => [s.dataset.b, s.dataset.i, s.value]);
      box.innerHTML = B.map(b => `
        <div class="bundle ${b.id === active ? 'on' : ''}" data-b="${b.id}" role="radio" aria-checked="${b.id === active}" tabindex="0">
          ${b.popular ? `<span class="popular">${b.popular.replace(' ', '<br>')}</span>` : ''}
          <div class="b-top"><span class="radio"></span>
            <div class="b-name"><div><b>${b.title}</b>${b.compare > b.price ? `<span class="tag">${saveTag(b)}</span>` : ''}</div><small>${b.sub}</small></div>
            <div class="b-price"><b>${money(b.price)}</b>${b.compare > b.price ? `<s>${money(b.compare)}</s>` : ''}</div></div>
          <div class="b-more">
            <div class="szrow">${Array.from({ length: b.qty }, (_, i) => `<div><label class="sel-l">${b.qty > 1 ? 'Suit ' + (i + 1) + ' size' : 'Size'}</label><select class="szsel" data-b="${b.id}" data-i="${i}">${sizeOpts}</select></div>`).join('')}</div>
            ${b.addons.map((a, i) => {
              const free = a.freeGift || a.display || !a.price;
              const chk = a.display && b.id === 1 ? 'none' : ((a.on || a.freeGift) ? 'on' : '');
              const label = (a.freeGift && !/^free/i.test(a.title) ? 'FREE ' : '') + a.title;
              return `<div class="addon" data-i="${i}"><span class="chk ${chk}"></span><span class="a-ic">${icon(a)}</span><span class="a-name">+ ${label}</span><span class="a-price ${free ? 'free' : ''}">${free ? 'FREE' : money(a.price)}${a.compare ? `<s>${money(a.compare)}</s>` : ''}</span></div>`;
            }).join('')}
          </div>
          ${b.id === 2 && b.addons.length ? `<div class="gifts"><span class="g-icons">${b.addons.map(a => `<span class="a-ic">${icon(a)}</span>`).join('')}</span>${(cfg.b2.giftsText || '{count} Free Gifts Included').replace('{count}', b.addons.length)}</div>` : ''}
        </div>`).join('');
      keep.forEach(([b, i, v]) => { const s = $(`.szsel[data-b="${b}"][data-i="${i}"]`, box); if (s) s.value = v; });
      $$('.szsel', box).forEach(s => { if (!keep.length) s.value = first.id; });
      upd();
    }
    function total() { const b = B[active - 1]; return b.price + b.addons.reduce((t, a) => t + (b.id === 1 && a.on && !a.fixed ? a.price : 0), 0); }
    function upd() { const st = $('[data-sticky-price]', prod); if (st) st.innerHTML = `${money(total())}<s>${money(B[active - 1].compare)}</s>`; }

    box.addEventListener('click', e => {
      if (e.target.closest('select')) return;
      const el = e.target.closest('.bundle'); if (!el) return;
      const id = +el.dataset.b;
      const ad = e.target.closest('.addon');
      if (ad && id === active && id === 1) {
        const a = B[0].addons[ad.dataset.i]; if (!a.fixed) { a.on = !a.on; ad.querySelector('.chk').classList.toggle('on', a.on); upd(); }
        return;
      }
      if (id !== active) { active = id; render(); }
    });
    box.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('bundle')) { e.preventDefault(); e.target.click(); } });
    render();

    document.addEventListener('pw:size', e => {
      const v = V.find(x => (x.option1 || x.title) === e.detail); if (!v) return;
      active = 1; render(); const s = $('.szsel[data-b="1"]', box); if (s) s.value = v.id;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    async function addToCart(btn) {
      const b = B[active - 1];
      const ids = $$(`.szsel[data-b="${b.id}"]`, box).map(s => +s.value);
      const items = [];
      ids.forEach(id => { const ex = items.find(x => x.id === id); ex ? ex.quantity++ : items.push({ id, quantity: 1, properties: b.qty > 1 ? { _bundle: 'Buy 2' } : {} }); });
      b.addons.forEach(a => {
        if (a.display) return;
        if (b.id === 1 && a.on && a.paid) items.push({ id: a.paid, quantity: 1 });
        if (b.id === 2) { if (a.free) items.push({ id: a.free, quantity: 1, properties: { _gift: 'Buy 2' } }); else console.warn('Pawrka: add a $0 variant to', a.title, 'so it can be a free gift'); }
      });
      const old = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      try {
        const r = await fetch((PW.routes.add || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        await openCart();
      } catch (err) { toast(err.message); }
      btn.disabled = false; btn.textContent = old;
    }
    const atc = $('[data-atc]', prod), atcS = $('[data-atc-sticky]', prod);
    atc.addEventListener('click', () => addToCart(atc));
    atcS && atcS.addEventListener('click', () => addToCart(atcS));
    const sticky = $('[data-sticky]', prod);
    if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(([e]) => sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(atc);
  }

  /* ---------- cart drawer ---------- */
  async function fetchCart() { const r = await fetch((PW.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  function drawCart(c) {
    const cc = $('#pwCC'); if (cc) { cc.textContent = c.item_count; cc.hidden = !c.item_count; }
    const body = $('#pwCartBody'); if (!body) return;
    body.innerHTML = c.items.length ? c.items.map((l, i) => `
      <div class="line">${l.image ? `<img src="${l.image + (l.image.includes('?') ? '&' : '?') + 'width=160'}" alt="">` : '<span class="a-ic"></span>'}
        <div class="li"><b>${l.product_title}</b>${l.variant_title && !/default title/i.test(l.variant_title) ? l.variant_title + '<br>' : ''}
          <span style="font-weight:800">${l.final_line_price ? money(l.final_line_price) : 'FREE'}</span>${l.original_line_price > l.final_line_price ? ` <s style="color:#8a95a8">${money(l.original_line_price)}</s>` : ''}
          <br><div class="qty"><button type="button" data-q="${i + 1}" data-n="${l.quantity - 1}" aria-label="Decrease">−</button><span>${l.quantity}</span><button type="button" data-q="${i + 1}" data-n="${l.quantity + 1}" aria-label="Increase">+</button></div>
        </div></div>`).join('') + (c.cart_level_discount_applications || []).map(d => `<p style="color:var(--ok);font-weight:800">${d.title}: −${money(d.total_allocated_amount)}</p>`).join('')
      : '<div class="empty">Your cart is empty<br><br><button class="btn2" type="button" data-close>Continue shopping</button></div>';
    const sub = $('#pwCartSub'); if (sub) sub.textContent = money(c.total_price);
  }
  async function openCart() { drawCart(await fetchCart()); open('pwCart'); }
  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-q]'); if (!q) return;
    const r = await fetch((PW.routes.change || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.dataset.q, quantity: Math.max(0, +q.dataset.n) }) });
    drawCart(await r.json());
  });

  /* ---------- size finder ---------- */
  const fd = $('[data-finder]');
  if (fd) {
    const rec = $('[data-rec]', fd);
    $$('.tabs button', fd).forEach(b => b.addEventListener('click', () => {
      $$('.tabs button', fd).forEach(x => x.classList.remove('on')); b.classList.add('on');
      $$('[data-tab]', fd).forEach(t => t.style.display = t.dataset.tab === b.dataset.t ? '' : 'none');
    }));
    const show = s => {
      rec.innerHTML = s ? `<div class="q">${s}</div><div><h4>Your Recommended Size</h4><p>Your princess is a <b>${s}</b>.</p><button class="btn2" type="button" style="height:40px;font-size:15px;margin-top:8px;padding:0 16px;width:auto" data-pick="${s}">Select ${s} &amp; shop</button></div>`
        : '<div class="q">?</div><div><h4>Your Recommended Size</h4><p>Pick a breed or enter measurements to see your size.</p></div>';
    };
    $('[data-breed]', fd).addEventListener('change', e => show(e.target.value));
    $('[data-find]', fd).addEventListener('click', () => {
      const w = parseFloat($('[data-wt]', fd).value), c = parseFloat($('[data-ch]', fd).value);
      if (!(w || c) || !SIZES.length) return show(null);
      const last = SIZES.length - 1;
      const iw = w ? SIZES.findIndex(z => w <= z.wMax) : 0, ic = c ? SIZES.findIndex(z => c <= z.cMax) : 0;
      show(SIZES[Math.max(iw < 0 ? last : iw, ic < 0 ? last : ic)].s);
    });
    fd.addEventListener('click', e => { const p = e.target.closest('[data-pick]'); if (p) document.dispatchEvent(new CustomEvent('pw:size', { detail: p.dataset.pick })); });
  }

  /* ---------- pack carousel ---------- */
  $$('[data-pack]').forEach(sec => {
    const sc = $('[data-pk-scroll]', sec), dots = $('[data-pk-dots]', sec); if (!sc || !sc.children.length) return;
    const step = () => sc.children[0].offsetWidth + 16;
    const idx = () => Math.round(sc.scrollLeft / step());
    const mark = () => [...dots.children].forEach((d, j) => d.classList.toggle('on', j === idx()));
    $$('[data-pk]', sec).forEach(b => b.addEventListener('click', () => {
      const i = Math.max(0, Math.min(sc.children.length - 1, idx() + +b.dataset.pk)); sc.scrollTo({ left: i * step(), behavior: 'smooth' });
    }));
    sc.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true }); mark();
  });

  /* ---------- scroll reveal ---------- */
  (function(){
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sel = '.eyebrow,.h2,.sub,.feat,.arch-wrap,.cmp tbody tr,.finder-card,.faq .acc,.pk-scroll,.rv-scroll,.seen,.hl,.mini .acc,.bs-title,.pk-dots,.paws-top';
    const els = [...document.querySelectorAll(sel)].filter(el => !el.closest('.gallery'));
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { const t=e.target; t.classList.add('in'); io.unobserve(t); setTimeout(()=>{t.style.transitionDelay='';}, 900); }
    }), { threshold: .12, rootMargin: '0px 300% -6% 300%' });
    els.forEach(el => {
      const sibs = [...el.parentElement.children].filter(c => c.matches(sel));
      el.style.transitionDelay = (Math.min(sibs.indexOf(el), 6) * 70) + 'ms';
      el.classList.add('pw-rv'); io.observe(el);
    });
  })();

})();
